module.exports = __webpack_public_path__ + "img/DE02059.14645b54.png";